export class SaveSurveyEntry
{
    surveyAppId: number;
    employeeId: string;
    corpId: string;
    authenticated: boolean;
    enteredBy: string;
    mobilePhoneNumber: string;
    //birthDate: string;
    birthDateMonth: number;
    birthDateDay: number;
    personalEmail: string;
    workEmail: string;
    firstName: string;
    lastName: string;
    items: Answer[];
    surveyEntryId: number;
    locationOrEventId: string;
}

export interface Answer
{
    questionFieldName: string;
    answerText: string;
}
